import FavouriteIcon from "./FavouriteIcon"
import ShareIcon from "./ShareIcon"

const FavouriteAndShare = ({ activityId }) => {
    return (
        <div className='flex gap-2 self-end text-xl'>
            <div className='flex gap-2 items-center'>
                <ShareIcon activityId={activityId} isBig />
                <FavouriteIcon activityId={activityId} isBig />
            </div>
        </div>
    )
}

export default FavouriteAndShare